import {LogoutGuard} from '@spartacus/storefront';
import {CmsService, ProtectedRoutesService, RoutingService, SemanticPathService} from '@spartacus/core';
import {Router} from '@angular/router';
import {Inject, Injectable, PLATFORM_ID} from '@angular/core';
import {SessionStorageService} from '@dcp/configurator';
import {OAuthService} from 'angular-oauth2-oidc';
import {isPlatformBrowser} from '@angular/common';
import {DcpAuthService} from '../services/dcp-auth.service';
import {DcpBaselineAuthService} from '@app/auth/services/dcp-baseline-auth.service';

const REFRESH_CART_FLAG: string = 'refreshCartFlag';

@Injectable({
  providedIn: 'root',
})
export class DcpLogoutGuard extends LogoutGuard {
  constructor(
    @Inject(PLATFORM_ID) public platformId: string,
    protected auth: DcpAuthService,
    protected cms: CmsService,
    protected semanticPathService: SemanticPathService,
    protected protectedRoutes: ProtectedRoutesService,
    protected router: Router,
    protected routingService: RoutingService,
    protected oAuthService: OAuthService,
    protected sessionStorageService: SessionStorageService,
    private readonly baselineAuthService: DcpBaselineAuthService
  ) {
    super(auth, cms, semanticPathService, protectedRoutes, router);
  }

  protected logout(): Promise<any> {
    if (isPlatformBrowser(this.platformId)) {
      // removing refreshCartFlag from the users session on logout - this is set again when the user logs in and thereby
      // restricts the user to perform full cart refresh only once per session
      this.sessionStorageService.removeItem(REFRESH_CART_FLAG);
      // We don't want to log the user back in
      this.oAuthService.stopAutomaticRefresh();
      // stop window.postMessage listeners
      this.oAuthService.ngOnDestroy();
    }

    return this.baselineAuthService.logout();
  }
}
